<template>
    <div class="ErrorMessage">
        <warning-icon class="ErrorMessage-icon"></warning-icon>
        {{message}}
    </div>
</template>

<script>
    export default {
        props: {
            message: {
                types: [String, Object]
            }
        },
    }
</script>
